<template>
  <!-- Sekme geçişi Bootstrap 5 Tab'ıyla (jQuery'siz): bağlantının href'indeki panel `show active` olur,
       `shown.bs.tab` `change` olarak yayılır. Tıklama ul'de dinlenir; sonradan gelen (v-if) sekmeler de çalışır. -->
  <ul :class="`nav nav-${pills ? 'pills' : ''}${tabs ? 'tabs' : ''} ${fill ? 'nav-fill' : ''} ${vertical ? 'flex-column' : ''} ${align ? 'justify-content-'+align : ''}`" :id="id"
      @click="onClick">
    <slot />
  </ul>
</template>
<script>
  import Tab from 'bootstrap/js/src/tab'

  export default {
    name: 'tab-nav',
    emits: ['change'],
    props: {
      id: { type: String, default: 'myTab' },
      pills: { type: Boolean, default: false },
      vertical: { type: Boolean, default: false },
      tabs: { type: Boolean, default: false },
      fill: { type: Boolean, default: false },
      align: { type: String, default: '' }
    },
    mounted() {
      this.$el.addEventListener('shown.bs.tab', this.onShown)
    },
    beforeUnmount() {
      this.$el.removeEventListener('shown.bs.tab', this.onShown)
    },
    methods: {
      onClick(event) {
        const link = event.target instanceof Element ? event.target.closest('a') : null
        if (!link || !this.$el.contains(link)) return
        // BS4 data-api'si (`data-toggle="tab"`) varsayılanı engelliyordu; adres çubuğuna #panel yazılmaz.
        event.preventDefault()
        Tab.getOrCreateInstance(link).show()
      },
      onShown(event) {
        this.$emit('change', event)
      }
    }
  }
</script>
